/** @format */

import { Pipe, PipeTransform } from "@angular/core";
import { NsEmpWebExpData } from "../models/emp-web-exp.model";
import { NsEmployeeWebExp } from "../models/env.model";

@Pipe({
  name: "seatText"
})
export class SeatTextPipe implements PipeTransform {
  transform(seat: NsEmpWebExpData.ISeatData | undefined, ofc: NsEmpWebExpData.IOffice): string {
    const notSelected = "";
    if (seat?.seatName) {
      return `${seat.seatName}, ${seat.floorName}, ${ofc.label}`;
    }
    return notSelected;
  }
}
